import { Component } from '@angular/core'

@Component({
  selector: 'ftr-supported-browsers-page',
  template: '<ftr-supported-browsers />',
  standalone: false,
})
export class SupportedBrowsersPage {}
